import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { PatchUserDto } from '../../types/user.types';
import { useAppMutation } from '../use-app-mutation.hook';

export const useUpdate = () => {
  const { mutate: update, isPending } = useAppMutation([QueryKey.PATCH_USER], {
    mutationFn: ({ data }: { data: PatchUserDto }) =>
      ApiService.patch({ endpoint: BackendRoute.USERS }, { body: data }),
  });
  return { update, isPending };
};
